import type { StorefrontEmbedAuditDto } from "@babackapp/private-api-client/generated/schema";

export type EmbedSummary = {
  loaded: number;
  active: number;
  inactive: number;
  unknown: number;
  withBabackScriptTag: number;
  readyToClean: number;
  cleaned: number;
  errors: number;
  activePercent: number;
};

export const isReadyToClean = (audit: StorefrontEmbedAuditDto): boolean =>
  audit.embedStatus === "active" && audit.babackScriptTags.length > 0;

export const summarize = (audits: StorefrontEmbedAuditDto[]): EmbedSummary => {
  const count = (predicate: (audit: StorefrontEmbedAuditDto) => boolean) =>
    audits.filter(predicate).length;
  const active = count((audit) => audit.embedStatus === "active");
  return {
    loaded: audits.length,
    active,
    inactive: count((audit) => audit.embedStatus === "inactive"),
    unknown: count((audit) => audit.embedStatus === "unknown"),
    withBabackScriptTag: count((audit) => audit.babackScriptTags.length > 0),
    readyToClean: count(isReadyToClean),
    cleaned: count(
      (audit) =>
        audit.embedStatus === "active" && audit.babackScriptTags.length === 0,
    ),
    errors: count((audit) => audit.error !== null),
    activePercent:
      audits.length > 0 ? Math.round((active / audits.length) * 100) : 0,
  };
};
